// extracted by mini-css-extract-plugin
module.exports = {"theme":"da51a739f7--theme--qg6_Y","fsk_fill_primary":"da51a739f7--fsk_fill_primary--uoQbR"};